import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

const statusColors: Record<string, { bg: string; color: string }> = {
  available: { bg: "rgba(182,138,88,0.15)", color: "#6b5b4a" },
  reserved: { bg: "rgba(212,180,131,0.25)", color: "#4a3728" },
  adopted: { bg: "rgba(107,91,74,0.12)", color: "#8a7a6a" },
};

const capitalize = (s: string) =>
  s ? s.charAt(0).toUpperCase() + s.slice(1) : "";

export const PuppieCard = ({
  id,
  name,
  description,
  sex,
  status,
  photo,
}: {
  id: number;
  name: string;
  description: string;
  sex: "male" | "female";
  status: "available" | "adopted" | "reserved";
  photo: string;
}) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        borderRadius: 2,
        backgroundColor: "rgba(255,255,255,0.8)",
        border: "1px solid #d4c4a8",
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: { xs: "100%", sm: 180 },
          height: { xs: 200, sm: 180 },
          objectFit: photo ? "cover" : "contain",
          backgroundColor: "#d4b483",
          flexShrink: 0,
          ...(!photo && { padding: "12.5%" }),
        }}
        image={photo || "/images/no_photo.png"}
        alt={name}
      />
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Typography
            component="div"
            variant="h6"
            sx={{
              fontFamily: '"Cinzel", serif',
              color: "#4a3728",
              fontSize: "1rem",
            }}
          >
            {name}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#6b5b4a", fontFamily: '"EB Garamond", serif' }}
          >
            {capitalize(sex)}
          </Typography>
          <Chip
            label={capitalize(status)}
            size="small"
            sx={{
              mt: 0.5,
              backgroundColor: (statusColors[status] || statusColors.available)
                .bg,
              color: (statusColors[status] || statusColors.available).color,
              fontWeight: 600,
              fontFamily: '"EB Garamond", serif',
            }}
          />
          <Typography
            variant="body2"
            component="div"
            sx={{ color: "#6b5b4a", mt: 1 }}
          >
            {description}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};
